export default __webpack_public_path__ + "static/media/error-page.99805bc0.webp";